import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router";
import { Loading } from "./Loading";
import { useWorkspaceContext } from "../hooks/useWorkspaceContext";

export function OwnerOnlyRoute({ children }: { children: ReactNode }) {
  const { workspaceId } = useParams();
  const workspace = useWorkspaceContext(workspaceId);

  if (workspace.isLoading) {
    return <Loading />;
  }
  if (workspace.data?.role !== "owner") {
    return <Navigate to={`/w/${workspaceId}/cache`} replace />;
  }

  return children;
}
